import React from 'react';
import { MessageCircle, Calendar, Sparkles } from 'lucide-react';
interface TopBarProps {
  onCalendarClick?: () => void;
  onChatClick?: () => void;
  onAskAIClick?: () => void;
}
export function TopBar({
  onCalendarClick,
  onChatClick,
  onAskAIClick
}: TopBarProps) {
  return <div className="px-4 py-6 flex items-center justify-between gap-3 bg-neutral-bg sticky top-0 z-10" data-id="element-117">
      {/* Chat Icon */}
      <button className="relative hover:bg-white/50 rounded-full p-2 transition-colors flex-shrink-0" aria-label="Team Chat" onClick={onChatClick} data-id="element-118">
        <MessageCircle className="w-6 h-6 text-gray-500" strokeWidth={2} data-id="element-119" />
        <span className="absolute top-1 right-1 w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-neutral-bg" data-id="element-120"></span>
      </button>

      {/* Ask AI Button - Glassmorphic */}
      <button className="px-6 py-2.5 rounded-full backdrop-blur-md bg-white/10 border border-white/20 hover:bg-white/20 transition-all flex items-center gap-2 shadow-lg" aria-label="Ask AI" onClick={onAskAIClick} data-id="element-121">
        <Sparkles className="w-5 h-5 text-purple-600" strokeWidth={2} data-id="element-122" />
        <span className="text-sm font-semibold text-gray-700" data-id="element-123">Ask AI</span>
      </button>

      {/* Calendar Icon */}
      <button className="relative hover:bg-white/50 rounded-full p-2 transition-colors flex-shrink-0" aria-label="Calendar and notifications" onClick={onCalendarClick} data-id="element-124">
        <Calendar className="w-6 h-6 text-gray-500" strokeWidth={2} data-id="element-125" />
        <span className="absolute top-1 right-1 w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-neutral-bg" data-id="element-126"></span>
      </button>
    </div>;
}